import React from 'react';
import { Check, Loader2, X } from 'lucide-react';

export type BulkRowStatus = 'idle' | 'pending' | 'success' | 'failure';

export interface BulkRowStatusBadgeProps {
  status: BulkRowStatus;
}

export const BulkRowStatusBadge: React.FC<BulkRowStatusBadgeProps> = ({ status }) => {
  if (status === 'idle') return null;
  if (status === 'pending') {
    return (
      <span aria-label="Action in progress" className="inline-flex text-muted-foreground">
        <Loader2 className="h-3 w-3 animate-spin" />
      </span>
    );
  }
  if (status === 'success') {
    return (
      <span aria-label="Succeeded" className="inline-flex text-success">
        <Check className="h-3 w-3" />
      </span>
    );
  }
  return (
    <span aria-label="Failed" className="inline-flex text-destructive">
      <X className="h-3 w-3" />
    </span>
  );
};
